import React, {useEffect, useRef, useState} from 'react';
import "./onboard-input-style.scss";
import Inputmask from "inputmask";
import parse from 'html-react-parser';
import {errorRandomReplace} from "../../../util/Validation";

const classNames = require('classnames');

const OnboardInput = (props) => {

    const {
        validation,
        error,
        value,
        onChange,
        mask,
        type,
        placeholder,
        upperAndEng,
        length,
        disabled,
        hint
    } = props;
    const inputRef = useRef();

    const [mValue, setMValue] = useState(value != null ? value : "");
    const [mError, setMError] = useState(error);
    const [mValid, setMValid] = useState(mValue.length > 0 ? validation : null);

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        setMValue(value != null ? value : "");
    }, [value]);

    useEffect(() => {
        if (mValue.length > 0) {
            setMValid(validation);
        } else {
            setMValid(null);
        }
    }, [validation]);

    const handleChange = (val) => {
        let text = val.target.value;
        text = text.replace(/([\p{Emoji_Presentation}|\p{Extended_Pictographic}|\u200D|\uFE0F])/gu, '');

        if (upperAndEng !== undefined) {
            text = text.toLocaleUpperCase("en-US")
                .replace("İ", "I")
                .replace("Ö", "O")
                .replace("Ç", "C")
                .replace("Ş", "S")
                .replace("Ğ", "G")
                .replace("Ü", "U");
            for (let char of text) {
                if (char !== ' ' && text.length > 0 && !/^[a-zA-Z]+$/.test(char)) return;
            }
            let lastText = text[text.length - 1];
            if (text[text.length - 1] !== ' ' && text.length > 0 && !/^[a-zA-Z]+$/.test(lastText)) return;
        }

        if (length !== undefined) {
            if (text.length > length) return;
        }

        if (error !== undefined) {
            setMError(null);
        }
        if (validation !== undefined) {
            if (mValid == null)
                setMValid(null);
        }

        setMValue(text);
        if (onChange !== undefined)
            onChange(text);
    }

    useEffect(() => {
        setMask();
        if (mValue !== undefined && mValue != null && mValue.length > 0) {
            inputRef.current.value = parse(mValue);
        }
    }, [])

    const setMask = () => {
        if (mask !== undefined) {
            Inputmask({
                ...mask
            }).mask(inputRef.current);
        }
    }

    const setClassName = () => {
        return classNames({
            'onboard-input-inp-error': (mError || (mValid && !hint))
        })
    }

    return (
        <div className="onboard-input-root">
            <div className="onboard-input-inp">
                <input ref={inputRef}
                       type={type === undefined ? 'text' : type}
                       placeholder="&nbsp;"
                       value={parse(mValue)}
                       onChange={(e) => handleChange(e)}
                       disabled={disabled}
                       className={setClassName()}>
                </input>
                <div className={"onboard-input-label " + ((mError || (mValid && !hint)) ? 'onboard-input-inp-error-label' : '')}>
                    {placeholder}
                </div>
                <span className="onboard-input-focus-bg"></span>
                {mError && (<div className="onboard-input-error-hint">{errorRandomReplace(mError)}</div>)}
                {(!mError && mValid && !hint) && (<div className="onboard-input-error-hint">{mValid}</div>)}
                {(!mError && mValid && hint) && (<div className="onboard-input-hint-hint">{mValid}</div>)}
            </div>
        </div>
    )
};

export default OnboardInput;
